module.exports = __webpack_public_path__ + "static/media/pinstripe-wordmark.a294d3fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/pinstripe-wordmark.png
// module id = 10
// module chunks = 0